class IndexedLocalStorage {
  constructor(dbName = 'obtoCSDB', storeName = 'obcs') {
    this.dbName = dbName;
    this.storeName = storeName;
    this.dbPromise = this.init();
  }

  async init() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, 1);

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(this.storeName)) {
          db.createObjectStore(this.storeName);
        }
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }

  async withStore(mode, callback) {
    const db = await this.dbPromise;
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(this.storeName, mode);
      const store = transaction.objectStore(this.storeName);
      const result = callback(store);
      transaction.oncomplete = () => resolve(result);
      transaction.onerror = () => reject(transaction.error);
    });
  }

  async getItem(key) {
    return this.withStore('readonly', (store) =>
      new Promise((resolve) => {
        const request = store.get(key);
        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => resolve(null);
      })
    );
  }

  async setItem(key, value) {
    return this.withStore('readwrite', (store) => {
      store.put(value, key);
    });
  }

  async removeItem(key) {
    return this.withStore('readwrite', (store) => {
      store.delete(key);
    });
  }

  async clear() {
    return this.withStore('readwrite', (store) => {
      store.clear();
    });
  }

  async key(index) {
    return this.withStore('readonly', (store) =>
      new Promise((resolve) => {
        const request = store.getAllKeys();
        request.onsuccess = () => resolve(request.result[index] || null);
        request.onerror = () => resolve(null);
      })
    );
  }

  async length() {
    return this.withStore('readonly', (store) =>
      new Promise((resolve) => {
        const request = store.count();
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => resolve(0);
      })
    );
  }
}

export default IndexedLocalStorage;